module.exports = __webpack_public_path__ + "img/message_8.9d1ae357.png";